import { useEffect, useState } from "react";
import { api } from "@/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export function DynamicFields({ entity, values, onChange }) {
  const [fields, setFields] = useState([]);

  useEffect(() => {
    api.get(`/custom-fields?entity=${entity}`).then((r) => setFields(r.data)).catch(() => {});
  }, [entity]);

  if (!fields.length) return null;

  return (
    <>
      {fields.map((f) => (
        <div key={f.field_id} className="space-y-1.5" data-testid={`custom-field-${f.label.toLowerCase().replace(/\s+/g, "-")}`}>
          <Label className="text-xs font-semibold text-slate-800 uppercase tracking-wider">{f.label}</Label>
          <Input
            type={f.field_type === "number" ? "number" : f.field_type === "date" ? "date" : "text"}
            value={values?.[f.field_id] || ""}
            onChange={(e) => onChange(f.field_id, e.target.value)}
            data-testid={`custom-field-input-${f.field_id}`}
            className="bg-slate-50/80 border-slate-300 placeholder:text-slate-400 focus:bg-white focus:border-emerald-500 focus:ring-2 focus:ring-emerald-500/20 hover:border-slate-400 transition-all duration-150 outline-none text-slate-900"
          />
        </div>
      ))}
    </>
  );
}
